import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as moment from 'moment-timezone';
import { AppModule } from './app/app.module';
import { environment } from './app/configs/environment';

moment.tz.setDefault('America/Montreal');
moment.locale('fr_CA');

Error['stackTraceLimit'] = Infinity;

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => {
		console.error(err);
	});
